import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { ExcelService } from 'src/app/service/excel.service'
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete';
import { DeleteDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-dialog.component';
import { EboiStateService } from 'src/app/service/eboi-state.service';
import { AddDailyExpediteComponent } from 'src/app/core/dialogs/add-daily-expedite/add-daily-expedite.component';
import { CopyTierDialogComponent } from 'src/app/core/dialogs/copy-tier-dialog/copy-tier-dialog.component';
import { ReasonidService } from 'src/app/service/reasonid.service';

@Component({
    selector: 'app-daily-expedite',
    templateUrl: './daily-expedite.component.html',
    styleUrls: ['./daily-expedite.component.scss'],
    standalone: false
})
export class DailyexpediteComponent implements OnInit {
  gridApi: any;
  successMessage
  errorMessage
  columnDefs = [];
  rowData = [];
  displayRowData = [];
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  gridOptions
  icons;
  context: any;
  periodData:[];
  selected_period_value: any;
  selected_period_id: any;
  domicileDrpDwn: any[];
  isAccessible: boolean;
  selected_from_period_id: any;
  period_id: any;
totalRecords = 0; 
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
    {value: 20 , selected : false},
		{value: 30 , selected : true},
		{value: 50 , selected : false},
	]
	originalPage: any;
  paginationPageSize: number = 30;
  dynamicHeight: number;
  constructor(private readonly router: Router, public dialog: MatDialog, private readonly excelService: ExcelService,
    private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly eboiStateService: EboiStateService, private readonly targetsService: ReasonidService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }

    this.gridOptions = {
			suppressCellSelection: true,
			context: this.context,
		  }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 50;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    // this.checkRoles()
    this.columnDefs = [
      {
        headerName: "Domicile", field: "domicile", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, width: 60, unSortIcon: true, sortable: true,
      },
      {
        headerName: "Daily Expedite Rate", field: "dailyExpediteRate", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, width: 80, unSortIcon: true, sortable: true,
      },
      {
        headerName: "Period", field: "periodName", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, width: 100, unSortIcon: true, sortable: true,
      },
      {
        headerName: "Year", field: "year", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', autoHeight: true, width: 100, unSortIcon: true, sortable: true,
      },
      {
        headerName: "Actions", field: "targetsActions", cellRenderer : BtnCellRendererEditDelete,
        width: 60
      },
    ];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.domicileDropdown();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  async checkRoles() {
    await this.eboiStateService.getRoles();
    const roles = this.eboiStateService.getroleState();
    // const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (!(userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser))) {
    //   this.openRouteLevel('home');
    // }  // Commented for APM integration
}

  async domicileDropdown() {
    await this.targetsService.domicileDrpDwn().then(x => {

      if (x && x.length > 0) {
        this.domicileDrpDwn = [];
        x.forEach(element => {
          this.domicileDrpDwn.push({ label: element, value: element })
        });
      }
    })
    this.displayRowData = []
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.targetsService.loadTargets().subscribe(
      response => {
        this.displayRowData = response
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        this.totalRecords= this.displayRowData.length;
          setTimeout(() => {
          this.updatePaginationDetails();
        });
       
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      },
      error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        this.defaultRowData();
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }

  goToNexpage() { this.gridApi.paginationGoToNextPage(); }



  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  

  refreshData() {
    this.displayRowData = []
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.targetsService.loadTargets().subscribe(
      response => {
        this.displayRowData = response
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        this.totalRecords=this.displayRowData.length;
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
         setTimeout(() => {
          this.updatePaginationDetails();
        });
       
      },
      error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        this.defaultRowData();
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }

  deleteTemplateRow(data) {
    const dialogRef = this.dialog.open(
      DeleteDialogComponent, {
      disableClose: true,
      width: '580px',
      data: {
        header: 'Are you sure you want to delete this Daily Expedite Target?',
        description: " Domicile : " + data.regionTargetId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == "ConfirmEvent") { // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.targetsService.deleteTargets(data.regionTargetId).subscribe(
          response => {
            if (response == "Success") { // NOSONAR
              this.successMessage = this.constants.APIDataDeleted;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
              this.refreshData();
            }
          }, error => {
            console.info(error)
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          })
      }
    }
    );
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }

  editTemplateRow(data) {
    const dialogRef = this.dialog.open(
      AddDailyExpediteComponent, {
      disableClose: true,
      width: '500px',
      data: {
        header: 'EDIT DAILY EXPEDITE TARGETS',
        eventType: 'EDIT',
        domicile: data.domicile,
        dailyexpediteRate: data.dailyExpediteRate,
        periodId: data.periodId,
        regionTargetId: data.regionTargetId,
        domicileDrpDwn: this.domicileDrpDwn,

      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR
        this.successMessage = this.constants.APIDataUpdated;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();
      }
    });
  }

  copyDialog(): void {
    const dialogRef = this.dialog.open(CopyTierDialogComponent, {
      disableClose: true,
      width: '500px',
      data: {
        header: 'COPY ALL',
        periodList: this.periodData
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'SaveEvent') { // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)        
        this.targetsService.copyTargets(Number(result.selected_from_period_id),Number(result.selected_period_id)).subscribe(
        
          response => {            
            if (response == "Success") { // NOSONAR
              this.successMessage = this.constants.APIDataSaved;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTime);
            }
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          }, error => {      
            console.info(error)      
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
          });

      }
    });
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }

  addexpedite() {
    const dialogRef = this.dialog.open(
      AddDailyExpediteComponent, {
      disableClose: true,
      width: '500px',
      data: {
        header: 'ADD DAILY EXPEDITE TARGETS',
        eventType: 'ADD',
        domicileDrpDwn: this.domicileDrpDwn,
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR

        this.successMessage = this.constants.APIDataSaved;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();

      }
    });
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }



  detailsTemplateRow(data) {
    if (data.shipmentId) {
      const shipmentId = data.shipmentId;
      localStorage.setItem('shipment-details', JSON.stringify(shipmentId));
      this.openRouteLevel('shipments/shipment-details')

    } else {
      this.errorMessage = "Error with shipment id.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }
  }

  onBtExport() {
    if (this.displayRowData?.length > 0) {
      const exportData = [];
      this.displayRowData.forEach(e => {
        const obj = {
          domicile: e.domicile,
          dailyExpediteRate: e.dailyExpediteRate,
          period: e.periodName,
          periodYear: e.year
        };
        exportData.push(obj);
      });

      const headers = ['Domicile', 'Daily Expedite Rate', 'Period', 'Year'];
      this.excelService.exportAsExcelFile(exportData, 'DAILY EXPEDITE TARGETS', headers);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  openRouteLevel(route) {
    this.router.navigate([`/${route}`]);
  }
 goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

	onPageSizeChanged(event: any) { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails(); }

	getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}
}